import React, { useEffect, useState } from 'react';
import { ClockIcon } from 'lucide-react';
const TOTAL_SECONDS = 17 * 60 + 34;
function pad(value: number) {
  return value.toString().padStart(2, '0');
}
export function CountdownTimer({
  label = 'La oferta se cierra en'
}: {
  label?: string;
}) {
  const [remaining, setRemaining] = useState(TOTAL_SECONDS);
  useEffect(() => {
    const interval = window.setInterval(() => {
      setRemaining(prev => prev <= 1 ? TOTAL_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(interval);
  }, []);
  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor(remaining % 3600 / 60);
  const seconds = remaining % 60;
  const units = [{
    value: pad(hours),
    tag: 'HORAS'
  }, {
    value: pad(minutes),
    tag: 'MIN'
  }, {
    value: pad(seconds),
    tag: 'SEG'
  }];
  return <div className="w-full max-w-md" data-id="element-60" data-mp="34pgswjbyfgg3">
      <p className="flex items-center justify-center gap-1.5 text-[12px] font-bold uppercase tracking-wider text-red-600 sm:text-sm" data-id="element-61" data-mp="34oe36eqdbk1r">
        <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-62" data-mp="1c0f6tej7qgv2" />
        {label}
      </p>
      <div className="mt-2 grid grid-cols-3 gap-2" role="timer" aria-live="off" aria-label={`Tiempo restante ${hours} horas ${minutes} minutos ${seconds} segundos`} data-id="element-63" data-mp="1h0b0oky74rww">
        {units.map(unit => <div key={unit.tag} className="rounded-xl border border-red-200 bg-white py-2 shadow-sm" data-id="element-64" data-mp="1723yj88kgeey">
            <div className="font-display text-2xl font-bold tabular-nums text-red-600 sm:text-3xl" data-id="element-65" data-mp="1utiw6npee7jv">
              {unit.value}
            </div>
            <div className="text-[10px] font-bold uppercase tracking-widest text-navy/45" data-id="element-66" data-mp="1l0bsd7ab2zlw">
              {unit.tag}
            </div>
          </div>)}
      </div>
    </div>;
}